import { Injectable } from '@angular/core';
import * as _ from 'lodash';
import { ConfigService } from './config.service';
import { BaseHttpService } from './base-http.service';
import { Observable } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { AuthenticationService } from './authentication.service';

@Injectable()

export class IndexesService extends BaseHttpService {

  constructor(public http: HttpClient,
    public configService: ConfigService,
    public authenticationService: AuthenticationService) {
    super(http);
  }

  getIndexes() {
    return this.get('question-tags');
  }
  getTaggedQuestionList(tagList: any) {
    const postobject = { tagList };
    return this.post('tagged-questions/', postobject);
  }

}

